import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { BASE_URL, MOCK_BASE_URL } from './config';

type BaseQueryOptions = { baseUrl: string; isMock?: never } | { baseUrl?: never; isMock: boolean };

type CreateBaseQuery = (
  url: string,
  options?: BaseQueryOptions
) => (args: any, api: any, extraOptions: any) => Promise<any>;

const isDev = import.meta.env.DEV;
const isMob = import.meta.env.VITE_MOB;

const prepareHeaders = async (headers: Headers) => {
  headers.set('Content-Type', 'application/json');

  if (isDev && isMob) {
    await import('@/utils/getCookieToken')
      .then((module) => {
        const auth = module.getCookieToken();
        if (auth) {
          headers.set('Authorization', ` ${auth}`);
        }
      })
      .catch((err) => {
        console.error('Failed to load the getCookieToken module', err);
      });
  }

  return headers;
};

const resolveBaseUrl = ({
  url,
  baseUrl,
  isMockEndpoint,
  isMock
}: {
  url: string;
  baseUrl?: string;
  isMockEndpoint?: boolean;
  isMock?: boolean;
}) => {
  const useMock = isMockEndpoint !== undefined ? isMockEndpoint : isMock;
  const resolvedBaseUrl = useMock ? MOCK_BASE_URL : baseUrl || BASE_URL;

  return `${resolvedBaseUrl}${url}`;
};

export const createBaseQuery: CreateBaseQuery = (url, options = { isMock: false }) => {
  const { baseUrl, isMock } = options || {};

  return async (args: any, api: any, extraOptions: any) => {
    const resolvedBaseUrl = resolveBaseUrl({
      url,
      baseUrl,
      isMockEndpoint: api.meta?.isMock,
      isMock
    });

    const baseQuery = fetchBaseQuery({
      baseUrl: resolvedBaseUrl,
      prepareHeaders
    });

    return baseQuery(args, api, extraOptions);
  };
};
